import { mapQuery } from 'utils/query';
import { Details } from 'components/details';
import { useDetailsQuery } from 'store/api/payout';
import { PaymentDetails } from 'components/payment-details';
import { BackCategoryButton } from 'components/back-category-button';

import { BonusDetailsDrawerProps } from './types';

export const BonusDetailsDrawer = ({
  id,
  onClose,
  title = 'Bonus',
}: BonusDetailsDrawerProps) => {
  const { data, ...props } = useDetailsQuery(String(id), { skip: !id });

  return (
    <Details {...mapQuery(props)}>
      <BackCategoryButton onClose={onClose} />
      <PaymentDetails
        data={data}
        title={title}
        disableSticky
        hideBackButton
        withoutPadding
      />
    </Details>
  );
};
